import { render } from "./VelocityGroup.vue?vue&type=template&id=605c640d&ts=true"
import script from "./VelocityGroup.vue?vue&type=script&lang=ts"
export * from "./VelocityGroup.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__